var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('search'),(_vm.hasResults)?_c('div',{staticClass:"container results"},[_c('tm-details'),_c('results')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }